import * as moment from "moment";
import React, { useEffect, useMemo, useState } from "react";
import { NumericFormat } from "react-number-format";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  Button,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Modal,
  ModalBody,
  UncontrolledDropdown
} from "reactstrap";
import { useRecoilState } from "recoil";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
} from "../../components/Component";
import Table from "../../components/react-table/Table";
import { DELETE, GET } from "../../helper/api";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import { popupCustomerFlowAtom, popupTransactionHistoryAtom } from "../../state";
import { bankHoookTransactionColTable } from "../../utils/col-table";

const BankHookTransactionDetail = () => {
  const [popupTransactionHistory, setPopupTransactionHistory] = useRecoilState(popupTransactionHistoryAtom);
  const [popupCustomerFlow, setPopupCustomerFlow] = useRecoilState(popupCustomerFlowAtom);

  const [data, setData] = useState({});
  const { id } = useParams()
  const [loading, setLoading] = useState(false);
  const [timeNow, setTimeNow] = useState();
  const [smOption, setSmOption] = useState(false);
  const [bankAccountOptions, setBankAccountOptions] = useState([]);
  const [deleteId, setDeleteId] = useState();
  const [view, setView] = useState({
    isDelete: false,
  });

  const colTable = bankHoookTransactionColTable({
    actionCol: []
  })

  const thColTable = [
    {
      Header: "Ngày",
      accessor: (item) => moment(item.date).format("DD/MM/YYYY"),
    },
    {
      Header: "KH/NCC",
      accessor: (item) => item.customer?.name
    },
    {
      Header: "Nội dung",
      accessor: (item) => item?.content || "",
    },
    {
      Header: "Danh mục",
      accessor: (item) => item?.category?.name || "",
    },
    {
      Header: "Tiền(đ)",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.amount}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />
    },
    {
      Header: "Hợp đồng",
      accessor: (item) => item.contractId || '',
    },
    {
      Header: "Ghi chú",
      accessor: () => "",
    },
    {
      Header: "Hành động",
      accessor: (item) => (
        <ul className="nk-tb-actions gx-1">
          <li>
            <UncontrolledDropdown>
              <DropdownToggle
                tag="a"
                className="btn btn-icon dropdown-toggle btn-trigger"
              >
                <Icon name="more-h"></Icon>
              </DropdownToggle>
              <DropdownMenu right>
                <ul className="link-list-opt no-bdr">
                  <li>
                    <DropdownItem
                      tag="a"
                      href="#edit"
                      onClick={(ev) => {
                        if (item.customerId) {
                          setPopupCustomerFlow({
                            show: true,
                            data: {
                              id: '',
                              type: '',
                              transactionId: item.id,
                              defaultValue: {
                                hookTransactionHistoryId: id,
                              }
                            }
                          })
                        } else {
                          setPopupTransactionHistory({
                            show: true,
                            data: {
                              id: item.id,
                              type: item.type,
                              defaultValue: {
                                hookTransactionHistoryId: id,
                              }
                            }
                          })
                        }

                      }}
                    >
                      <Icon name="edit"></Icon>
                      <span>Cập nhật</span>
                    </DropdownItem>
                  </li>
                  <li>
                    <DropdownItem
                      tag="a"
                      href="#dropdown"
                      onClick={(ev) => {
                        ev.preventDefault();
                        setDeleteId(item.id);
                        toggle("isDelete");
                      }}
                    >
                      <Icon name="trash" className="text-danger"></Icon>
                      <span>Xoá</span>
                    </DropdownItem>
                  </li>
                </ul>
              </DropdownMenu>
            </UncontrolledDropdown>
          </li>
        </ul>
      ),
    },
  ]

  useEffect(() => {

    GET(`/hook-transaction-history/${id}`, {}, true)
      .then(({ data }) => {
        setData(data);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [timeNow, id, popupTransactionHistory, popupCustomerFlow]);

  useEffect(() => {
    GET(`bank-account`, {}, true).then((resp) => {
      setBankAccountOptions(
        resp.data.filter(e => !!e.bankNumber).map((c) => ({
          label: `${c.name}`,
          value: c.id,
          data: c,
        }))
      );
    });
  }, []);

  const bankAccount = useMemo(() => {
    return bankAccountOptions.find(e => e?.data?.bankNumber === data?.bankNumber)?.data
  }, [bankAccountOptions, data])

  const lessAmount = useMemo(() => {
    return (data?.amount || 0) - (data?.transactionHistoryTotal || 0)
  }, [data])

  // function to close the form modal
  const onFormCancel = () => {
    setView({ isDelete: false });
  };

  // toggle function to view order details
  const toggle = (type) => {
    setView({
      ...view,
      [type]: !view[type],
    });
  };

  const resetData = () => {
    onFormCancel();
    setTimeNow(moment().valueOf());
  };


  const deleteOrder = (id) => {
    if (!id) {
      return;
    }
    DELETE(`transaction-history/${id}`, {}, true)
      .then((res) => {
        toast.success("Xóa giao dịch thành công");
        resetData();
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      });
  };


  return (
    <React.Fragment>
      <Head title="Quản lý đề xuất chi"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Chi tiết giao dịch số {data?.id}</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div
                  className="toggle-expand-content"
                  style={{ display: smOption ? "block" : "none" }}
                >
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div className="bg-white">
            <Table
              notShowPagi
              loading={loading}
              columns={colTable}
              data={[data]}
              conditionHighlightRow={(item) => item.amount !== item.transactionHistoryTotal ? 'font-weight-bold text-danger' : ''}
              style={{
                minHeight: 'unset !important'
              }}
            ></Table>
          </div>
          <div className="w-100">
            <h5 className="mb-4">
              Danh sách giao dịch nội bộ
              {data?.type === 'IN' &&
                <>
                  <Button
                    disabled={loading || !data}
                    className="float-right ml-2"
                    color="primary"
                    type='button'
                    onClick={() => {
                      setPopupTransactionHistory({
                        show: true,
                        data: {
                          id: '',
                          type: 'IN',
                          defaultValue: {
                            hookTransactionHistoryId: id,
                            content: data.content,
                            amount: lessAmount,
                            date: moment(data.createdAt).format('YYYY-MM-DD'),
                            ...(bankAccount ? {
                              bankAccountId: bankAccount.id,
                            } : {})
                          }
                        }
                      })
                    }}
                  >
                    <Icon name="plus"></Icon>
                    <span>Thêm thu</span>
                  </Button>

                  <Button
                    disabled={loading || !data}
                    className="float-right ml-2"
                    color="primary"
                    type='button'
                    onClick={() => {
                      setPopupCustomerFlow({
                        show: true,
                        data: {
                          id: '',
                          type: 'IN',
                          defaultValue: {
                            hookTransactionHistoryId: id,
                            content: data.content,
                            amount: lessAmount,
                            date: moment(data.createdAt).format('YYYY-MM-DD'),
                            ...(bankAccount ? {
                              bankAccountId: bankAccount.id,
                            } : {})
                          }
                        }
                      })
                    }}
                  >
                    <Icon name="plus"></Icon>
                    <span>Thêm thu KH/NCC</span>
                  </Button>
                </>
              }

              {data?.type === 'OUT' &&
                <>
                  <Button
                    disabled={loading || !data}
                    className="float-right ml-2"
                    color="primary"
                    type='button'
                    onClick={() => {
                      setPopupTransactionHistory({
                        show: true,
                        data: {
                          id: '',
                          type: 'OUT',
                          defaultValue: {
                            content: data.content,
                            hookTransactionHistoryId: id,
                            amount: lessAmount,
                            date: moment(data.createdAt).format('YYYY-MM-DD'),
                            ...(bankAccount ? {
                              bankAccountId: bankAccount.id,
                            } : {})
                          }

                        }
                      })
                    }}
                  >
                    <Icon name="plus"></Icon>
                    <span>Thêm chi</span>
                  </Button>
                  <Button
                    disabled={loading || !data}
                    className="float-right ml-2"
                    color="primary"
                    type='button'
                    onClick={() => {
                      setPopupCustomerFlow({
                        show: true,
                        data: {
                          id: '',
                          type: 'OUT',
                          defaultValue: {
                            content: data.content,
                            hookTransactionHistoryId: id,
                            amount: lessAmount,
                            date: moment(data.createdAt).format('YYYY-MM-DD'),
                            ...(bankAccount ? {
                              bankAccountId: bankAccount.id,
                            } : {})
                          }

                        }
                      })
                    }}
                  >
                    <Icon name="plus"></Icon>
                    <span>Thêm chi KH/NCC</span>
                  </Button>
                </>
              }
            </h5>
          </div>

          <div className="card card-bordered card-preview">
            <div className="card-inner">
              <div
                id="DataTables_Table_1_wrapper"
                className="dataTables_wrapper dt-bootstrap4 no-footer"
              >
                <Table
                  notShowPagi
                  loading={loading}
                  columns={thColTable}
                  data={data?.transactionHistories || []}
                ></Table>
              </div>
            </div>
          </div>
          <Modal isOpen={view.isDelete} toggle={() => onFormCancel()}>
            <ModalBody className="modal-body-lg text-center">
              <div className="nk-modal">
                <Icon className="nk-modal-icon icon-circle icon-circle-xxl ni ni-cross bg-danger"></Icon>
                <h4 className="nk-modal-title">
                  Bạn có chắc muốn xoá giao dịch này không ?{" "}
                </h4>
                <div className="nk-modal-action mt-5 d-flex justify-content-around">
                  <Button
                    color="light"
                    size="lg"
                    className="btn-mw mr-5"
                    onClick={() => onFormCancel()}
                  >
                    Huỷ bỏ
                  </Button>
                  <Button
                    color="primary"
                    size="lg"
                    className="btn-mw"
                    onClick={(ev) => {
                      ev.preventDefault();
                      deleteOrder(deleteId);
                    }}
                  >
                    Xác nhận
                  </Button>
                </div>
              </div>
            </ModalBody>
          </Modal>
        </Block>
      </Content>
    </React.Fragment>
  );
};

export default BankHookTransactionDetail;
